import { render, staticRenderFns } from "./add-template.vue?vue&type=template&id=5655ba7a&scoped=true"
import script from "./add-template.vue?vue&type=script&lang=ts"
export * from "./add-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5655ba7a",
  null
  
)

export default component.exports